import {useSelector} from 'react-redux';
import * as css from './LoginByBtn.css';
import {XHR_LOADING_STATE} from '../../../../assets/constants/constants';

function LoginByBtn({text, className ,onClick}) {

    const isKeyboardOpen=useSelector(s=>s.ui.isKeyboardOpen);
    
    // Check if any login-related XHR is in loading state to prevent duplicate calls
    const loginByEmailXHR = useSelector((state) => state.user?.loginByEmailXHR);
    const loginUserXHR = useSelector((state) => state.user?.loginUserXHR);
    
    // Disable if any login action is loading
    const isDisabled = loginByEmailXHR === XHR_LOADING_STATE || 
                      loginUserXHR === XHR_LOADING_STATE;

    const handleClick = () => {
        // Prevent duplicate calls by checking loading states
        if(isDisabled) {
            return;
        }
        onClick();
    };

    return (
        <css.button 
            onClick={handleClick}  
            id ="loginByPassword"  
            data-cy ="loginByPassword" 
            className={`${isKeyboardOpen&&className==='google'&&'hidden'} ${isDisabled ? 'disabled' : ''}`}
        >
            <css.logo className={className} />
            <css.text>{text}</css.text>
        </css.button>
    );
}

export default LoginByBtn;
